import React from 'react';

import {
  Container,
  TolltipItens,
  TooltipContainer,
  TootipTitle,
} from './styles';

type CustomTooltipProps = {
  title: string;
  className?: string;
  componentShow: () => React.ReactNode;
  children: React.ReactNode;
};

const CustomToolip: React.FC<CustomTooltipProps> = ({
  title,
  className,
  componentShow,
  children,
}) => {
  return (
    <Container className={className}>
      {children}
      <TooltipContainer>
        {title && <TootipTitle>{title}</TootipTitle>}
        <TolltipItens>{componentShow()}</TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default CustomToolip;
